/** 展示信息 URL 上限（C4：官网 / 隐私政策 / 服务条款） */
export const DISPLAY_URL_MAX = 1000

/** 非空字符串是否为带主机名的 https URL，且不超过展示信息长度上限 */
export function isHttpsUrl(value: string): boolean {
  if (value.length > DISPLAY_URL_MAX) return false
  try {
    const url = new URL(value)
    return url.protocol === 'https:' && url.hostname.length > 0
  } catch {
    return false
  }
}

/** 选填 URL：空白通过；有内容则必须是 https URL */
export function isOptionalHttpsUrl(value: string | undefined): boolean {
  const next = value?.trim() ?? ''
  if (!next) return true
  return isHttpsUrl(next)
}

/** 去掉首尾空白；纯空白视为空字符串（落库前规范化） */
export function trimDisplayUrl(value: string | undefined): string | undefined {
  if (value == null) return value
  return value.trim()
}
